import script from "./YearTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./YearTotals.vue?vue&type=script&setup=true&lang=ts"

import "./YearTotals.vue?vue&type=style&index=0&id=057f8920&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057f8920"]])

export default __exports__